export default __webpack_public_path__ + "static/108-min-min-d04dfd959a484056b81bf0cafa4981f3.jpg";